import { useSelector } from 'react-redux';
import type Feature from '@alltrails/types/Feature';

export default function useFeatures(): Feature[] {
  return useSelector((state: { features: Feature[] }) => state.features || []);
}
